import React from "react";
import ProductSettings from "./components/ProductSettings";

const QuantityGrid = () => {
  return <ProductSettings />;
};

export default QuantityGrid;
